module.exports = __webpack_public_path__ + "img/tiaomakuaishu04-450.2fa7a801.png";